import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
var _excluded = ["theme"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.sort.js";
import getProperty from "../../helpers/getProperty";
import isObject from "../../helpers/isObject";
import isTruthy from "../../helpers/isTruthy";

var defaultTransformationFunction = function defaultTransformationFunction(propValue, _ref) {
  var themeValue = _ref.themeValue,
      _ref$addPx = _ref.addPx,
      addPx = _ref$addPx === void 0 ? true : _ref$addPx;

  if (themeValue && ( // TODO подумать
  typeof themeValue === "string" || typeof themeValue === "number")) {
    return String(themeValue);
  }

  if (typeof propValue === "number") {
    return "".concat(propValue).concat(addPx ? "px" : "");
  }

  return String(propValue);
};

export default function createStyledEnhancer(options) {
  var propName = options.name,
      _options$alias = options.alias,
      alias = _options$alias === void 0 ? [] : _options$alias,
      _options$keys = options.keys,
      keys = _options$keys === void 0 ? [] : _options$keys,
      _options$workLikeGetB = options.workLikeGetByPathOnKeys,
      workLikeGetByPathOnKeys = _options$workLikeGetB === void 0 ? [] : _options$workLikeGetB,
      _options$directTransf = options.directTransformation,
      directTransformation = _options$directTransf === void 0 ? false : _options$directTransf,
      _options$transformati = options.transformation,
      transformation = _options$transformati === void 0 ? defaultTransformationFunction : _options$transformati;

  var styleEnhancer = function styleEnhancer(properties) {
    if (!propName || ![].concat(_toConsumableArray(alias), [propName]).some(function (property) {
      return Object.prototype.hasOwnProperty.call(properties, property) && typeof properties[property] !== "undefined";
    })) {
      return {};
    }

    var theme = properties.theme,
        componentProps = _objectWithoutProperties(properties, _excluded);

    var propValue = componentProps[propName];

    if (!isTruthy(propValue) && Array.isArray(alias)) {
      var aliasName = alias.find(function (x) {
        return isTruthy(componentProps[x]);
      });

      if (aliasName) {
        propValue = componentProps[aliasName];
      }
    }

    var getTransformationResult = function getTransformationResult(unTransformedValue) {
      var themeValue;

      if (keys.length > 0 && typeof unTransformedValue === "string") {
        themeValue = keys.map(function (themeValueKey) {
          return getProperty(theme, "".concat(themeValueKey, ".").concat(unTransformedValue));
        }).find(Boolean);
      }

      if (!themeValue && workLikeGetByPathOnKeys.length > 0 && typeof unTransformedValue === "string" && workLikeGetByPathOnKeys.find(function (key) {
        return unTransformedValue.startsWith(key);
      })) {
        themeValue = getProperty(theme, unTransformedValue);
      }

      var result = transformation(unTransformedValue, _objectSpread(_objectSpread({}, options), {}, {
        theme: theme,
        themeValue: themeValue
      }));
      return directTransformation ? result : _defineProperty({}, propName, result);
    }; // Если был передан объект, он будет обработан как breakpoints


    if (isObject(propValue)) {
      var _properties$theme = properties.theme,
          breakpoints = _properties$theme.breakpoints,
          simpleBreakpointsOrder = _properties$theme.simpleBreakpointsOrder,
          _properties$theme$bre = _properties$theme.breakpointsHelpers,
          up = _properties$theme$bre.up,
          between = _properties$theme$bre.between,
          isComplexBreakpoint = _properties$theme$bre.isComplexBreakpoint,
          isSimpleBreakpoint = _properties$theme$bre.isSimpleBreakpoint;

      var _Object$entries$reduc = Object.entries(propValue).reduce(function (accumulator, breakpoint) {
        var _breakpoint = _slicedToArray(breakpoint, 1),
            breakpointKey = _breakpoint[0];

        if (isSimpleBreakpoint(breakpointKey)) {
          accumulator.mediaQueries.push(breakpoint);
        }

        if (isComplexBreakpoint(breakpointKey)) {
          accumulator.customMediaQueries.push(breakpoint);
        }

        return accumulator;
      }, {
        mediaQueries: [],
        customMediaQueries: []
      }),
          mediaQueries = _Object$entries$reduc.mediaQueries,
          customMediaQueries = _Object$entries$reduc.customMediaQueries;
      /*
       * Сортировка, чтобы не был важен порядок брекпоитов передаваемом свойстве
       * например {lg: 20, sm: 10} => {sm: 10, lg: 20}
       */


      mediaQueries.sort(function (_ref3, _ref4) {
        var _ref5 = _slicedToArray(_ref3, 1),
            a = _ref5[0];

        var _ref6 = _slicedToArray(_ref4, 1),
            b = _ref6[0];

        return simpleBreakpointsOrder.indexOf(a) > simpleBreakpointsOrder.indexOf(b) ? 1 : -1;
      });
      /*
       * Обработка кастомных брекпоинтов,
       * вызывается функция из темы чтобы получить медиа выражение
       */

      var resultWithMediaQueries = customMediaQueries.reduce(function (accumulator, _ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
            breakpointKey = _ref8[0],
            breakpointValue = _ref8[1];

        return _objectSpread(_objectSpread({}, accumulator), {}, _defineProperty({}, breakpoints[breakpointKey], getTransformationResult(breakpointValue)));
      }, {});
      /*
       * Отбработка обычных брекпоитов
       * в зависимости от наличия подряд идующих брекпоинтов строится медиа выражение
       */

      resultWithMediaQueries = mediaQueries.reduce(function (accumulator, _ref9) {
        var _ref10 = _slicedToArray(_ref9, 2),
            breakpointKey = _ref10[0],
            breakpointValue = _ref10[1];

        // Находим следующий брекпоинт в общем списке брекпоитов
        var nextBreakpoint = simpleBreakpointsOrder[simpleBreakpointsOrder.indexOf(breakpointKey) + 1]; // Проверяем был ли он передан в компонент

        var themeIsNextBreakpoint = nextBreakpoint ? Boolean(mediaQueries.find(function (_ref11) {
          var _ref12 = _slicedToArray(_ref11, 1),
              breakpointKeyToFind = _ref12[0];

          return breakpointKeyToFind === nextBreakpoint;
        })) : false;
        return _objectSpread(_objectSpread({}, accumulator), {}, _defineProperty({}, themeIsNextBreakpoint ? between(breakpointKey, nextBreakpoint) : up(breakpointKey), getTransformationResult(breakpointValue)));
      }, resultWithMediaQueries);
      return resultWithMediaQueries;
    }

    return getTransformationResult(propValue);
  };

  return styleEnhancer;
}